import React from "react";
import ChooseUS from "../ChooseUs";
import Footer from "../Footer";
import Navbar from "../Navbar";

function WhyChooseUsPage() {
  return (
    <div>
      <Navbar />
      <ChooseUS />
      <Footer />
    </div>
  );
}

export default WhyChooseUsPage;
